/* Shared collection/search/recommendation cards. Native product bundles are separate. */
(function () {
  'use strict';
  if (window.psListingCardsLoaded) return;
  window.psListingCardsLoaded = true;
  var sequence = 0;
  function init(scope) {
    var cards = Array.from(scope.querySelectorAll('[data-ps-listing-card]'));
    if (scope.matches && scope.matches('[data-ps-listing-card]')) cards.unshift(scope);
    cards.forEach(function (card) {
      if (card.dataset.psListingReady) return;
      var state = card.querySelector('[data-ps-listing-variants]');
      if (!state) return;
      var variants;
      try { variants = JSON.parse(state.textContent); } catch (_) { return; }
      card.dataset.psListingReady = 'true';
      var form = card.querySelector('form.feature-product-form');
      var select = form && form.querySelector('.product-form__input-select');
      var hidden = form && form.querySelector('.product-variant-id');
      var instance = ++sequence;
      if (form) {
        form.id = 'ps-card-form-' + instance;
        form.querySelectorAll('input[type="radio"][data-variant-id]').forEach(function (input) {
          var label = form.querySelector('label[data-variant-id="' + input.dataset.variantId + '"]');
          input.id = 'ps-card-option-' + instance + '-' + input.dataset.variantId;
          input.name = 'ps-card-option-' + instance;
          if (label) label.htmlFor = input.id;
        });
        if (select) {
          var selectLabel = form.querySelector('label[for="' + select.id + '"]');
          select.id = 'ps-card-select-' + instance;
          if (selectLabel) selectLabel.htmlFor = select.id;
        }
      }
      function sync(id) {
        var variant = variants.find(function (item) { return String(item.id) === String(id); });
        if (!variant) return;
        var template = card.querySelector('template[data-ps-listing-variant="' + variant.id + '"]');
        if (!template) return;
        card.dataset.psVariantId = String(variant.id);
        if (hidden) hidden.value = variant.id;
        if (select) select.value = variant.id;
        if (form) {
          form.querySelectorAll('input[type="radio"][data-variant-id]').forEach(function (input) { input.checked = input.dataset.variantId === String(variant.id); });
          form.querySelectorAll('label[data-variant-id]').forEach(function (label) { label.classList.toggle('active', label.dataset.variantId === String(variant.id)); });
          var optionValue = form.querySelector('.option_value');
          if (optionValue) optionValue.textContent = variant.title;
          var submit = form.querySelector('.product_submit_button');
          if (submit) {
            submit.disabled = !variant.available;
            submit.classList.toggle('btn--disabled', !variant.available);
            var submitLabel = submit.querySelector('.btn-label');
            var strings = window.variantStrings || {};
            if (submitLabel) submitLabel.textContent = variant.available ? strings.addToCart || 'Add to Cart' : strings.soldOut || 'Sold out';
          }
        }
        var price = card.querySelector('.product-item__price');
        if (price) price.replaceChildren(template.content.querySelector('[data-ps-listing-price]').cloneNode(true));
        var label = card.querySelector('[data-ps-listing-label]');
        if (label) label.replaceWith(template.content.querySelector('[data-ps-listing-label]').cloneNode(true));
        var productImage = card.querySelector('img.product-image.first-image');
        if (productImage && template.dataset.image) {
          productImage.src = template.dataset.image;
          productImage.srcset = template.dataset.image;
        }
        card.querySelectorAll('[data-ps-listing-link]').forEach(function (link) {
          var url = new URL(link.href, location.href);
          url.searchParams.set('variant', variant.id);
          var offer = template.content.querySelector('[data-required-quantity]');
          if (variant.available && offer) url.searchParams.set('ps_quantity', offer.dataset.requiredQuantity);
          else url.searchParams.delete('ps_quantity');
          link.href = url.pathname + url.search + url.hash;
        });
      }
      var initial = select && select.value || hidden && hidden.value;
      if (!initial) {
        var available = variants.filter(function (variant) { return variant.available; }).sort(function (a, b) { return a.price - b.price; });
        initial = (available[0] || variants[0] || {}).id;
      }
      if (initial) sync(initial);
      if (form) {
        form.addEventListener('click', function (event) {
          var label = event.target.closest('label[data-variant-id]');
          if (!label || !form.contains(label)) return;
          event.preventDefault();
          var variant = variants.find(function (item) { return String(item.id) === label.dataset.variantId; });
          if (variant && variant.available) sync(variant.id);
        });
        form.addEventListener('change', function (event) {
          if (event.target === select || event.target.matches('input[type="radio"][data-variant-id]')) sync(event.target.dataset.variantId || event.target.value);
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  // Collection filters and predictive search replace cards after the initial page load.
  var queued = false;
  var observer = new MutationObserver(function (records) {
    if (queued || !records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('[data-ps-listing-card]') || node.querySelector('[data-ps-listing-card]')); }); })) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(document); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}());
